import * as React from "react"

import { cn } from "./cn"

/*
  The surface every text-entry control shares — Input, Textarea, Select. One
  string, so a field's border, fill and focus state change in one place.
*/
export const FIELD =
  "w-full rounded-md border border-hairline bg-surface px-3 py-2 text-ui text-text-1 placeholder:text-text-3 focus-visible:outline-hidden focus:bg-surface-strong focus:border-accent ring-0 focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50";

/*
  `code` is the one-time-code field both the signup and the passkey-recovery flows
  use: the same input, centred and a step up the type scale so six digits read as
  a unit. It was a hand-copied class string at every call site before.
*/
const VARIANT = {
  default: "",
  code: "text-center text-subhead",
} as const;

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: keyof typeof VARIANT;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        className={cn(
          FIELD,
          "flex h-12 file:border-0 file:bg-transparent file:text-ui file:font-medium",
          VARIANT[variant],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
)
Input.displayName = "Input"

export { Input }
